import gql from 'graphql-tag'
export default gql`mutation deleteConsistencyTestTypeMutation($consistencyTestTypeId: Int!) {
  deleteConsistencyTestType(consistencyTestTypeId: $consistencyTestTypeId) {
    success
  }
}`